import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { isNotEmptyArray, renderWithLinks } from 'utils';

import ProgramsCard from './ProgramsCard';
import { CardList, CardSlider } from '../widgets/DataRenderer';
import LinkBack from '../widgets/LinkBack';
import Spinner from '../widgets/Spinner';

import './programs.scss';

const blockName = {
  examples: 'Примеры',
  'realized-programs': 'Реализованные <br/>программы',
  'current-programs': 'Текущие <br/>программы'
};

const blockLink = {
  'realized-programs': 'current-programs',
  'current-programs': 'realized-programs'
};

class ProgramsTemplate extends PureComponent {
  render() {
    const { status, isMobile, programs } = this.props;

    const items = programs.results.map(item => {
      const cardProps = Object.assign({}, item, {
        onClick: () => this.props.onCardClick(item.id),
        previewText: renderWithLinks(item.previewText)
      });

      return <ProgramsCard {...cardProps} />;
    });

    const ListComponent = isMobile ? CardList : CardSlider;

    return (
      <div className="programs">
        <Helmet>
          <title>{this.props.content.title}</title>
        </Helmet>

        <div className="programs-content">
          <div className="container">
            <LinkBack link={this.props.content.link}>
              {this.props.content.title} <i>вернуться</i>
            </LinkBack>

            <h1
              className="programs-title"
              dangerouslySetInnerHTML={{ __html: blockName[status] }}
            />
          </div>

          <div className="data-renderer-container">
            <div className="container">
              {(isNotEmptyArray(items)) &&
                <ListComponent items={items} />
              }

              {(!isNotEmptyArray(programs.results) && programs.isFetching) &&
                <div className="programs-spinner">
                  <Spinner />
                </div>
              }
            </div>
          </div>

          {(!!blockLink[status]) && (!this.props.content.disableButtons) &&
            <div className="container">
              <div className="programs-current">
                <Link
                  className="btn btn-arrowed"
                  to={`${this.props.content.link}${blockLink[status]}/`}
                >
                  <span dangerouslySetInnerHTML={{ __html: blockName[blockLink[status]] }} />
                  <span className="icon">→</span>
                </Link>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

ProgramsTemplate.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string
  }),
  programs: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  status: PropTypes.oneOf([
    'examples',
    'realized-programs',
    'current-programs'
  ]),
  isMobile: PropTypes.bool,
  onCardClick: PropTypes.func
};

export default ProgramsTemplate;



// WEBPACK FOOTER //
// ./src/components/Programs/ProgramsTemplate.js